import styled from 'styled-components';
import { Fonts } from '@whispir/ui-lib-v2';

export const FormWrapper = styled.div`
  .time-title {
    ${Fonts.body};
    padding-bottom: 24px;
  }
`;
